import {
  //token,
  user,
  forgotPassword,
  resetPassword,
  verifyEmail,
  userRegister,
  sendToMail,
  verifyCode,
  tokenWithProvider,
  userChangePassword,
  token,
  logout,
  verify2fa,
  resend2fa
} from '../../routes/api/paths';
import { BASE_URL } from "../../routes/app/paths";
import { decryptJson } from '../../utils/crypt';
import { encryptStorage } from '../../utils/encryptStorage';
import { handleResponse, requestOptions } from '../HandlerService';

const handleAuthResponse = async (response) => {
  if (!response.ok) {
    return Promise.reject(response.status);
  }
  if (response.status) {
    if (response.status === 204 || response.status === 302) {
      return Promise.resolve({
        status: response.status,
        data: {},
      });
    }

    const data = await response.json();
    const dataDecrypted = data?.data ? decryptJson((data.data)) : decryptJson(data);

    // save expiration date in local storage (solo si no requiere 2FA)
    if (!dataDecrypted.require_tfa) {
      const expirationDate = new Date(new Date().getTime() + data.expires_in * 1000);
      encryptStorage.setItem('expirationDate', expirationDate);
    }

    return Promise.resolve({
      status: response.status,
      data: dataDecrypted,
    });
  }
};


export const TokenService = async function (userInfo) {
  const options = requestOptions('POST', userInfo.queryKey[0]);
  return fetch(token, options)
    .then(handleAuthResponse)
    .catch(error => {
      return Promise.reject({ status: error });
    });
};

export const TokenWithProviderService = async (loginInfo) => {
  const options = requestOptions('POST', loginInfo);
  return fetch(tokenWithProvider, options)
    .then(handleAuthResponse)
    .catch(error => {
      if (error === 404) {
        return Promise.resolve({
          status: error,
          data: {
            error: 'User not found'
          }
        });
      }
      return Promise.reject({ status: error });
    });
};

export const UserService = (token) => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token.queryKey[0]
    }
  };
  return fetch(user, options)
    .then(async response => {
      if (!response.ok) {
        return Promise.reject(response.status);
      }

      const data = await response.json();
      const dataDecrypted = data?.data ? decryptJson((data.data)) : decryptJson(data);
      return {
        status: response.status,
        user: {
          ...dataDecrypted,
          access_token: token.queryKey[0]
        }
      }
    })
    .catch(error => Promise.reject({ status: error }));
};

export const UserRegisterService = (data) => {
  const options = requestOptions('POST', data.queryKey[0]);
  return fetch(userRegister, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
};

export const ForgotPasswordService = (info) => {
  const options = requestOptions('POST', {
    email: info.queryKey[0],
    url: `${BASE_URL}/`
  });
  return fetch(forgotPassword, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
};

export const ResetPasswordService = (data) => {
  const options = requestOptions('POST', {
    email: data.queryKey[0],
    password: data.queryKey[1],
    code: data.queryKey[2]
  });
  return fetch(resetPassword, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
};

export const UserChangePasswordService = (data) => {
  const { token, password } = data;
  const options = requestOptions('PUT', {
    password
  }, token);
  return fetch(userChangePassword, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
};

export const ConfirmRegisterService = (data) => {
  const options = requestOptions('POST', data.queryKey[0]);
  return fetch(verifyEmail, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
};

export const ValidateEmailService = async (data) => {
  const dataToSend = {
    email: data.queryKey[0],
    verification_code: data.queryKey[1]
  };
  const options = requestOptions('POST', dataToSend);
  return fetch(verifyEmail, options)
    .then(handleAuthResponse)
    .catch(error => Promise.reject({ status: error }));
};

export const VerifyCodeService = async (data) => {
  const dataToSend = {
    email: data.queryKey[0],
    code: data.queryKey[1]
  };
  const options = requestOptions('POST', dataToSend);
  return fetch(verifyCode, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
};

export const ResendCodeService = async (data) => {
  const dataToSend = {
    email: data.queryKey[0],
  };
  const options = requestOptions('POST', dataToSend);
  return fetch(sendToMail, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
};

/* Google */
export const GetDataFromGoogle = async (data) => {
  const { access_token } = data;
  const url = `https://www.googleapis.com/oauth2/v1/userinfo`;
  const options = requestOptions('GET', {}, access_token);
  return fetch(url, options)
    .then((res) => {
      if (!res.ok) {
        return Promise.reject(res.status);
      }
      return res.json();

    })
    .catch(error => Promise.reject({ status: error }));
}

export const LogoutService = async (data) => {
  const { token: accessToken } = data;
  const options = requestOptions('POST', {}, accessToken);
  return fetch(logout, options)
    .then(handleAuthResponse)
    .catch(error => Promise.reject({ status: error }));
};

export const Verify2FAService = async (data) => {
  const options = requestOptions('POST', data.queryKey[0]);
  return fetch(verify2fa, options)
    .then(handleAuthResponse)
    .catch(error => {
      return Promise.reject({ status: error });
    });
};

export const Resend2FAService = async (data) => {
  const options = requestOptions('POST', data.queryKey[0]);
  return fetch(resend2fa, options)
    .then(handleResponse)
    .catch(error => {
      return Promise.reject({ status: error });
    });
};